import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Modal from 'react-bootstrap/Modal';
import { CustomSignIn } from 'evm-chain-scripts';
import './CustomSignIn.scss';

function CustomSignInForm({ className, show, onClose }) {
  return (
    <Modal className={classnames('sign-in-form', className)} show={show} centered onHide={onClose}>
      <Modal.Body className="text-left">
        <CustomSignIn
          titleClassName="text-center"
          signInClassName="btn btn-primary mr-3"
          signOutClassName="btn btn-danger"
          inputClassName="form-control mb-3"
          onClose={onClose}
        />
      </Modal.Body>
    </Modal>
  );
}

CustomSignInForm.propTypes = {
  className: PropTypes.string,
  show: PropTypes.bool,
  onClose: PropTypes.func
};

export default memo(CustomSignInForm);
